/// Format an ISO timestamp as a human-readable date. Falls back to
/// the raw string if Date parsing fails — server always sends RFC 3339,
/// but defensive against future format drift.
export function formatDeletionDate(iso: string): string {
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) {
    return iso;
  }
  return date.toLocaleString(undefined, {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
  });
}
